export default __webpack_public_path__ + "static/media/experiment-card.74f4e86f.svg";